import React, { FC } from 'react';
import CurrencyPrice from '../../../../common/currency-price/currency-price';
import translation from '../../../../languages';
import { VoucherPropsType } from './voucher';
import VoucherErrors from './voucher-errors';

type MobileVoucherPropsType = VoucherPropsType & {
    detachVoucher: () => void
}

const MobileVoucher: FC<MobileVoucherPropsType> = (props) => {
    const { cart, voucherCode, attachVoucher, handleVoucher, handleVoucherInputKeyPress, detachVoucher, t } = props;
    const isAppliedPromo = cart?.promo?.applied;
    const isAppliedPromoVoucher = isAppliedPromo && cart?.voucher?.code;

    return (
        <div>
            {(cart.voucher && !isAppliedPromoVoucher) && (
                <div>
                    <div className='applied-voucher-info d-flex'>
                        <div className='pull-left lmp-h-5 code'>
                            <div>{t('cart.cartSummary.voucherCode')}</div>
                            <span>{cart.voucher.code}</span>
                        </div>
                        <div className='lmp-h-5 discount text-right'>
                            <CurrencyPrice price={cart.totalVoucherDiscount} />
                        </div>
                    </div>
                    <div className='text-right'>
                        <span className='lmp-link' onClick={detachVoucher}>
                            x {t('cart.cartSummary.remove')}
                        </span>
                    </div>
                </div>
            )}
            {(isAppliedPromoVoucher || !cart.voucher) && (
                <div className='voucher-info'>
                    <div className='lmp-secondary'>
                        <b>{t('cart.cartSummary.voucherCode')}</b>
                    </div>
                    <div className='input-group'>
                        <input
                            className='form-control'
                            placeholder={t('cart.cartSummary.enterTheCode')}
                            type='text'
                            value={voucherCode}
                            onChange={handleVoucher}
                            onKeyPress={(e) => handleVoucherInputKeyPress(e)}
                        />
                        <div className='input-group'>
                            <span className='input-group-text' onClick={() => attachVoucher()}>
                                {t('cart.cartSummary.apply')}
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <VoucherErrors voucherError={cart.voucherError} />
        </div>
    );
};

const translate = translation('cart');

export default translate(MobileVoucher);
